import { readonly, ref } from 'vue'
import {
  loadShokzValidationConfig,
  resetShokzValidationConfigCache
} from '@/composables/shokz-config'
import { isDevFullMenu } from '@/utils/app-config'

const shokzEnabled = ref(false)
let loaded = false

/**
 * 加载韶音租户开关（读取配置管理 custom.validation.enabled = shokz）。
 */
export async function loadShokzFeature(force = false): Promise<boolean> {
  if (loaded && !force) {
    return shokzEnabled.value
  }
  if (isDevFullMenu()) {
    shokzEnabled.value = true
    loaded = true
    if (import.meta.env.DEV) {
      console.log('[CT_SHOKZ]', { config: 'dev-full-menu', enabled: true, loaded: true })
    }
    return true
  }

  try {
    const enabled = await loadShokzValidationConfig({ force })
    if (enabled) {
      shokzEnabled.value = true
      loaded = true
    } else if (shokzEnabled.value) {
      // extension 有数据但配置未拉到时的兜底（company-form）
      loaded = true
      if (import.meta.env.DEV) {
        console.warn('[CT_SHOKZ] config not shokz, keep enabled=true from fallback')
      }
    } else {
      shokzEnabled.value = false
      loaded = false
    }
  } catch {
    if (!shokzEnabled.value) {
      shokzEnabled.value = false
      loaded = false
    }
  }
  return shokzEnabled.value
}

/** 编辑页等场景：extension 有数据但配置未拉到时的兜底 */
export function setShokzTenantEnabled(enabled: boolean): void {
  shokzEnabled.value = enabled
  loaded = true
}

export function resetShokzFeatureCache(): void {
  loaded = false
  shokzEnabled.value = false
  resetShokzValidationConfigCache()
}

/**
 * 韶音租户特性开关（客商属性页签、MDM 导入、文控等）
 */
export function useShokzFeature() {
  return {
    isShokzTenant: readonly(shokzEnabled),
    loadShokzFeature,
    setShokzTenantEnabled,
    resetShokzFeatureCache
  }
}

if (import.meta.env.DEV) {
  ;(globalThis as typeof globalThis & {
    __CT_SHOKZ__?: {
      loadShokzFeature: typeof loadShokzFeature
      setShokzTenantEnabled: typeof setShokzTenantEnabled
      resetShokzFeatureCache: typeof resetShokzFeatureCache
      get enabled(): boolean
    }
  }).__CT_SHOKZ__ = {
    loadShokzFeature,
    setShokzTenantEnabled,
    resetShokzFeatureCache,
    get enabled() {
      return shokzEnabled.value
    }
  }
}
